export default {
  default: {
    linkTextAdmin: 'Admin Settings',
    linkTextAccount: 'Account Settings',
  },
}
